<template>
  <v-dialog v-model="show" class="modal" persistent max-width="500px" scrollable>
    <v-card style="overflow-y: auto">
      <v-container>
        <v-layout>
          <v-flex>
            <v-card-title primary-title class="pl-0">
              <span class="attendee-field-title">
                {{ workflowLabel(headerText) }}
              </span>
            </v-card-title>
            <div class="mb-22 attendee-field-description">{{ adminText('workflowsAll.choose_type_of_attendee_field_d00389a', 'Choose type of attendee field') }}</div>
          </v-flex>
          <v-flex style="text-align: end; padding-top: 16px">
            <v-btn icon @click="closeDialog">
              <v-icon color="#979797">clear</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout v-if="attendeesExist && action === 'update'" align-center class="error-container">
          <span class="error-message">
            {{ adminText('workflowsAll.type_label_and_options_are_locked_because_att_fc8bffa', 'Type, label and options are locked because attendees already exist.') }}
          </span>
        </v-layout>
        <attendee-field-form
          v-if="show"
          :vs="$v"
          :initial-values="form"
          :fields="fields"
          :attendees-exist="attendeesExist"
          :action="action"
          @values="form = $event"
        />
      </v-container>
      <div class="buttons-container">
        <main-button
          v-if="!attendeesExist"
          class="action-button"
          color="error"
          flat
          :text="adminText('workflowsAll.delete_f6fdbe4', 'Delete')"
          @click="emitDelete"
        />
        <main-button depressed class="action-button" :text="workflowLabel(okText)" @click="submitForm" />
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import { required, maxLength } from 'vuelidate/lib/validators'

import AttendeeFieldForm from './attendee-field-form.vue'
import { notIn } from '../../validators'

export default {
  mixins: [WorkflowDisplay],
  name: 'attendee-field-dialog',
  components: {
    AttendeeFieldForm,
  },
  props: {
    show: Boolean,
    deletable: Boolean,
    action: {
      type: String,
      validator: value => ['add', 'update'].indexOf(value) !== -1,
    },
    attendeesExist: Boolean,
    fields: {
      type: Array,
      default: () => [],
    },
    field: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      form: this.field,
    }
  },
  computed: {
    headerText() {
      return this.action === 'add' ? this.adminText('workflowsAll.new_attendee_field_a78bce4', 'New attendee field') : this.adminText('workflowsAll.update_attendee_field_591e724', 'Update attendee field')
    },
    okText() {
      return this.action === 'add' ? this.adminText('workflowsAll.save_efc007a', 'Save') : this.adminText('workflowsAll.update_fb91e24', 'Update')
    },
  },
  watch: {
    field: {
      handler(val) {
        this.form = val
      },
    },
  },
  validations() {
    return {
      form: {
        name: {
          required,
          notIn: notIn(
            this.fields.map(f => f.name),
            this.field.name,
          ),
          maxLength: maxLength(80),
        },
        value: {
          component: {
            required,
          },
        },
      },
    }
  },
  methods: {
    async submitForm() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        if (this.form.value.items) {
          this.form.value.items = this.form.value.items.filter(item => item !== '')
        }
        const { value, ...rest } = this.form
        const validations = value.validations
        if (!value.type) {
          value.type = 'text'
        }
        if (this.action === 'add' && this.attendeesExist) {
          this.$emit('submit', {
            ...rest,
            ...value,
            validations: { ...validations, required: false },
          })
        } else {
          this.$emit('submit', { ...rest, ...value, ...validations })
        }
        this.closeDialog()
      }
    },
    emitDelete() {
      const { id } = this.form
      if (id) {
        this.$emit('delete', id)
        this.closeDialog()
      }
    },
    closeDialog() {
      this.form = { validations: {} }
      this.$v.$reset()
      this.$emit('update:show', false)
    },
  },
}
</script>

<style scoped>
::v-deep .v-dialog--scrollable {
  background-color: #fff;
}
.action-button {
  margin: 0 0 16px 24px !important;
  width: 94px !important;
  height: 36px !important;
}
.container {
  padding: 0 32px;
}
.error-message {
  width: 100%;
  background-color: #f3263e6b;
  padding-left: 42px;
}
.error-container {
  padding-bottom: 16px;
}
.attendee-field-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 1.25rem;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #0277bd;
}
.attendee-field-description {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 1rem;
  color: #979797;
}
.buttons-container {
  display: flex;
  justify-content: flex-end;
  padding-right: 30px;
}
</style>
